import { createContext, useCallback, useContext } from 'react'

export type UiState = {
  paletteOpen: boolean
  setPaletteOpen: (open: boolean) => void
  newIssueOpen: boolean
  setNewIssueOpen: (open: boolean) => void
  /** Issue number whose detail Sheet is open, or null. */
  sheetIssue: number | null
  setSheetIssue: (number: number | null) => void
}

export const UiStateContext = createContext<UiState | null>(null)

export function useUiState(): UiState {
  const ctx = useContext(UiStateContext)
  if (!ctx) throw new Error('useUiState outside UiStateProvider')
  return ctx
}

/** Stable callback for opening an issue's Sheet — safe to pass into memoized cards. */
export function useOpenIssueSheet(): (issue: { number: number }) => void {
  const { setSheetIssue } = useUiState()
  return useCallback((issue: { number: number }) => setSheetIssue(issue.number), [setSheetIssue])
}
